var map = {
	"./review-small1.png": 26534,
	"./review-small2.png": 15468,
	"./review-small3.png": 56018,
	"./review-small4.png": 41743,
	"./review-small5.png": 78974,
	"./review1.png": 5551,
	"./review2.png": 47680,
	"./review3.png": 60777,
	"./review4.png": 13678,
	"./review5.png": 61480,
	"./review6.png": 95834,
	"./review7.png": 83354,
	"./review8.png": 31590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52514;